// The names the rule generator stamps on each condition group, and on the conditions tree
// itself. They are part of the persisted rule shape, so they are read far from where they are
// written — by three stop-colouring call sites, by the rules provider, and (since DP-3292) by
// the colorized-indicators worker in nxtgen-services, which matches `MANIFESTONLY` against the
// root `conditions.name` to decide a rule stamps no stop.
//
// Kept in its own dependency-free module rather than in RuleGenerator.service: that file
// imports from DispatchRulesDataProvider, so a consumer in the provider would close an import
// cycle. Re-exported from RuleGenerator.service so existing imports keep working.
export enum ConditionNames {
  JOBATTRIBUTES = "JobAttributes",
  JOBATTRIBUTES_CUSTOMER = "JobAttributes_Customer",
  JOBATTRIBUTES_SERVICE = "JobAttributes_Service",
  JOBATTRIBUTES_VEHICLE = "JobAttributes_Vehicle",
  ORDERPRIORITY = "OrderPriorities",
  MANIFESTONLY = "ManifestOnly",
  MANIFESTATTRIBUTES = "ManifestAttributes",
  MANIFESTATTRIBUTES_STATUS = "ManifestAttributes_Status",
  JOBTYPEVALUE = "JobTypeValue",
  COMPARATOR = "Comparator"
}
